import React, { Component } from 'react';

import { Grid, Row, Col} from 'react-bootstrap';

class History extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <Grid>
          <Row>
            <Col sm={12} md={3}>
              <div className="timeLine">
                    <div className="dataPoint"><p/> <h4>1962 <br/><br/> Gründung</h4></div>
                  <div className="dataPoint"><p/> <h4>1979 <br/><br/> Übernahme durch <br/> Günther Scholz</h4></div>
                  <div className="dataPoint"><p/> <h4>2002 <br/><br/> Übernahme durch <br/> Dieter Mrochen</h4></div>
                  <div class="line"></div>

              </div>
            </Col>
            <Col sm={12} md={8}>
              <div className="historyInfo">
                <h1>Firmenhistorie</h1>
                <br/>
                <h4>
                Im Jahr 1962 wurde die Firma Joh. Rolf Mauersberger gegründet.
                Unser Einsatz ist damals wie heute eine intensive Beratung und Verkauf
                von hochwertigen Industrieausrüstungen.
                <br/><br/>
                Unser Wissen und die individuellen Einsatzbedürfnisse unterschiedlichster Industriekunden haben zu unserem stetigen Wachstum beigetragen. Mit der Übernahme 1979 durch Herrn Günther Scholz entwickelten wir uns zu einer leistungsstarken und flexiblen Industrievertretung weiter und sind stolz bei der Einführung von heute weltweit führenden Produkten mitgewirkt zu haben.
                <br/><br/>
                Unsere treuen Kunden profitieren von jahrzehntelanger Kenntnis der Berufs- und Industrieanforderung und können sich so gegenüber dem harten Wettbewerb behaupten.
                <br/><br/>
                Mauersberger Industrievertretungen e.K. bürgt nachwie vor für Sicherheit, Qualität, Vertrauen und Zuverlässigkeit. In der Beratung, Ausführung und im Verkauf.
              </h4>
              </div>
            </Col>

          </Row>
        </Grid>


        </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/components/pages/history.js